import React from "react";



const Main = () => {

  return (
    <div className="container">
      <h1 className="text-center mt-5 text-danger">Welcome My Checkout Page</h1>
    </div>
  );
};

export default Main;
